function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0b543;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 47,
  cy: 47,
  r: 47
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M591.245,497.548v-.008a1.9,1.9,0,0,0-1.412-1.428c-2.781-.678-7.156.045-12,1.986a38.609,38.609,0,0,0-12.559,7.953,29.932,29.932,0,0,0-2.758,3.157,12.232,12.232,0,0,0-5.466.878c-5.388,2.371-6.927,8.44-7.337,10.932a2.333,2.333,0,0,0,2.537,2.706h.012l6-.655c.007.077.016.147.022.211a3.207,3.207,0,0,0,.924,1.934l2.93,2.931a3.2,3.2,0,0,0,1.933.925l.2.021-.653,6v.012a2.333,2.333,0,0,0,2.081,2.561q.108.011.216.012a2.352,2.352,0,0,0,.387-.032c2.506-.4,8.572-1.923,10.937-7.341a12.342,12.342,0,0,0,.882-5.444,29.366,29.366,0,0,0,3.168-2.758,38.329,38.329,0,0,0,7.961-12.461C591.179,504.843,591.906,500.435,591.245,497.548Zm-9.991,16.32a5.485,5.485,0,1,1,0-7.756l0,0a5.441,5.441,0,0,1,.058,7.694Z",
  transform: "translate(-523.58 -469.767)"
});

function SvgIconInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon_inventory.16299d06.svg";
export { ForwardRef as ReactComponent };